export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14477.d0a35f2e.jpg";